<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card tile>
          <v-card-title>{{
            $t("common." + (edition_mode ? "edit" : "add"))
          }}</v-card-title>
          <v-divider />
          <v-alert type="warning" v-if="dateExist">
            {{ $t("common.duplicate_date") }}
          </v-alert>
          <v-card-text>
            <v-form ref="form">
              <UserPicker
                required
                v-model="formModel.user"
                :label="$t('user.select-pef')"
              />
              <DatePicker
                required
                v-model="formModel.date"
                :label="$tc('common.date', 1)"
              />
              <v-autocomplete
                v-model="selected_types"
                :items="ao_type"
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                :label="$t('ao.type.title')"
                multiple
                @change="onChange"
                deletable-chips
                :menu-props="{ closeOnContentClick: true }"
              ></v-autocomplete>
              <span v-if="selected_types.length > 0"
                ><b>{{ $t("common.quantity_for") }}</b></span
              >
              <div v-for="type in ao_type" :key="type.id">
                <div v-if="selected_types.includes(type.id)">
                  <v-text-field
                    v-model="quantities[type.id]"
                    :label="type.name"
                    required
                    type="number"
                  />
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-btn text @click="$router.go(-1)">{{
              $t("common.cancel")
            }}</v-btn>
            <v-spacer />
            <v-btn tile color="primary" :loading="loading" @click="_submit">{{
              $t("common.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from "@/components/form/DatePicker"
import { mapActions } from "vuex"
import { ADD, UPDATE, FETCH_ONE, FETCH } from "@/store/action-types"
import FormMixin from "@/mixins/FormMixin"
import UserPicker from "@/components/form/UserPicker"

export default {
  name: "aoForm",
  components: { UserPicker, DatePicker },
  mixins: [FormMixin],
  computed: {
    required_rule() {
      return [(v) => !!v || this.$t("errors.field_required")]
    },
    ao_type() {
      return this.$store.state.ao_type.data
    },
  },
  data() {
    return {
      dateExist: false,
      selected_types: [],
      quantities: {},
      formModel: {
        user: {},
        date: null,
        types: [],
      },
    }
  },
  async mounted() {
    if (this.ao_type.length === 0) {
      await this.fetchType()
    }
    if (this.$route.params.ao_id) {
      this.edition_mode = true
      let self = this
      await this.FETCH_ONE(this.$route.params.ao_id)
        .then((data) => {
          self.$set(self, "formModel", data)
          this.formModel.types.forEach((item) => {
            this.quantities[item.type_id] = item.count
            this.selected_types.push(item.type_id)
          })
        })
        .finally(() => {
          self.loading = false
        })
    } else {
      this.$set(this.formModel, "user", {
        id: Number(this.$route.params.user_id),
      })
    }
  },

  methods: {
    ...mapActions("ao", [FETCH, FETCH_ONE, UPDATE, ADD]),
    ...mapActions("ao_type", { fetchType: FETCH }),

    onChange(item) {
      let self = this
      item.forEach((item) => {
        if (!Object.keys(self.quantities).includes(item.toString())) {
          this.$set(self.quantities, item, 1)
        }
      })
      Object.keys(this.quantities).forEach((id) => {
        if (!item.includes(Number(id))) {
          this.$delete(self.quantities, id)
        }
      })
    },
    _submit() {
      this.formModel.types = Object.keys(this.quantities).map((item) => {
        return { type_id: item, count: this.quantities[item] }
      })
      this.submit(
        ["user", "id", "date", "types"],
        (data) => "/users/" + data.user.id,
        "user"
      )
    },
  },
  watch: {
    "formModel.date"(val) {
      let self = this
      this.FETCH({ date: val, user_id: this.user_id })
        .then((data) => {
          self.dateExist = data.data.length > 1
        })
        .finally(() => {})
    },
  },
}
</script>
